var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-container-sitc",
      staticStyle: { "padding-bottom": "0px" },
    },
    [
      _c("div", { staticClass: "filter-container-content" }, [
        _c("div", { staticClass: "desciption-content" }, [
          _c("div", { ref: "tableAutoRef", staticStyle: { width: "97%" } }, [
            _c("div", { staticClass: "desciption-content-info" }, [
              _c("div", { staticClass: "content-info-area" }, [
                _c("div", [
                  _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
                    _c("span", { staticClass: "info-title" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$t(
                              "booking.bookingHistroryJpDetails.companyNameInfo"
                            )
                          ) +
                          "\n                  "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "info-text" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.custerInfo.companyName) +
                          "\n                  "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
                    _c("span", { staticClass: "info-title" }, [
                      _vm._v(
                        "\n                     " +
                          _vm._s(
                            _vm.$t("booking.bookingHistroryJpDetails.telInfo")
                          ) +
                          "\n                  "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "info-text" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.custerInfo.tel) +
                          "\n                  "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("span", { staticClass: "info-title" }, [
                      _vm._v(
                        "\n                     " +
                          _vm._s(
                            _vm.$t(
                              "booking.bookingHistroryJpDetails.e_mailInfo"
                            )
                          ) +
                          "\n                  "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "info-text" }, [
                      _vm._v(
                        "\n                   " +
                          _vm._s(_vm.custerInfo.activateEmail) +
                          "\n                  "
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("div", { staticStyle: { "margin-right": "30px" } }, [
                    _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
                      _c("span", { staticClass: "info-title" }, [
                        _vm._v(
                          "\n                     " +
                            _vm._s(
                              _vm.$t(
                                "booking.bookingHistroryJpDetails.contactInfo"
                              )
                            ) +
                            "\n                  "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "info-text" }, [
                        _vm._v(
                          "\n                       " +
                            _vm._s(_vm.custerInfo.accountName) +
                            "\n                     "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticStyle: { "margin-bottom": "10px" } }, [
                      _c("span", { staticClass: "info-title" }, [
                        _vm._v(
                          "\n                      " +
                            _vm._s(
                              _vm.$t("booking.bookingHistroryJpDetails.faxInfo")
                            ) +
                            "\n                  "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "info-text" }, [
                        _vm._v(
                          "\n                      " +
                            _vm._s(_vm.custerInfo.fax) +
                            "\n                     "
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "desciption-content-title" }, [
              _vm._v("\n            BOOKING\n            "),
              _c("span", { staticStyle: { color: "rgba(199,78,81,1)" } }, [
                _vm._v(
                  "\n              " + _vm._s(_vm.detialType) + "\n            "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content-table-title" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.$t(
                      "booking.bookingHistroryJpDetails.bookingDetailTitle"
                    )
                  ) +
                  "\n          "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { width: "40%" } }, [
              _c(
                "table",
                {
                  staticStyle: { "border-collapse": "collapse" },
                  attrs: {
                    align: "center",
                    width: "100%",
                    border: "1px solid rgb(204,204,204)",
                    cellpadding: "10",
                  },
                },
                [
                  _c("tbody", [
                    _c("tr", [
                      _c("td", { staticClass: "table-item-titel" }, [
                        _vm._v(
                          "\n                  Booking No.\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              _vm.webBookingHead.bkNo
                                ? _vm.webBookingHead.bkNo
                                : "NOT FIXED"
                            ) +
                            "\n                "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "table-item-titel" }, [
                        _vm._v(
                          "\n                  Booking Status\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.statusLabel) +
                            "\n                "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "table-item-titel" }, [
                        _vm._v(
                          "\n                 " +
                            _vm._s(
                              _vm.$t(
                                "booking.bookingHistroryJpDetails.PortofReceipt"
                              )
                            ) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.polNameList.porName) +
                            "  CY\n                "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "table-item-titel" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              _vm.$t("booking.bookingHistroryJpDetails.POL")
                            ) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                  " +
                            _vm._s(_vm.polNameList.polName) +
                            "\n                "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "table-item-titel" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              _vm.$t("booking.bookingHistroryJpDetails.POD")
                            ) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n                 " +
                            _vm._s(_vm.polNameList.podName) +
                            "\n                "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "table-item-titel" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              _vm.$t(
                                "booking.bookingHistroryJpDetails.PortofDelivery"
                              )
                            ) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "div",
                          [
                            _c(
                              "el-radio",
                              {
                                attrs: {
                                  label: 0,
                                  disabled: _vm.detialType == "Preview",
                                },
                                on: { change: _vm.delRadioChange },
                                model: {
                                  value: _vm.webBookingHead.tsFlag,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.webBookingHead, "tsFlag", $$v)
                                  },
                                  expression: "webBookingHead.tsFlag",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                      " +
                                    _vm._s(_vm.polNameList.delName1) +
                                    " CY\n                    "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticStyle: { "margin-top": "20px" } },
                          [
                            _c(
                              "el-row",
                              { attrs: { gutter: 24 } },
                              [
                                _c(
                                  "el-col",
                                  { attrs: { span: 3 } },
                                  [
                                    _c(
                                      "el-radio",
                                      {
                                        staticStyle: {
                                          position: "relative",
                                          top: "5px",
                                        },
                                        attrs: {
                                          label: 1,
                                          disabled: _vm.detialType == "Preview",
                                        },
                                        on: { change: _vm.delRadioChange },
                                        model: {
                                          value: _vm.webBookingHead.tsFlag,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.webBookingHead,
                                              "tsFlag",
                                              $$v
                                            )
                                          },
                                          expression: "webBookingHead.tsFlag",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                           \n                        "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-col",
                                  { attrs: { span: 21 } },
                                  [
                                    _c("gl-port", {
                                      attrs: {
                                        disabled:
                                          _vm.webBookingHead.tsFlag == "0",
                                        placeholder: "",
                                      },
                                      model: {
                                        value: _vm.polNameList.delName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.polNameList,
                                            "delName",
                                            $$v
                                          )
                                        },
                                        expression: "polNameList.delName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "table-item-titel" }, [
                        _vm._v(
                          "\n                  Shipping Term:\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "80%" },
                              attrs: {
                                disabled: _vm.detialType == "Preview",
                                placeholder: "",
                              },
                              model: {
                                value: _vm.webBookingHead.transportationTerms,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.webBookingHead,
                                    "transportationTerms",
                                    $$v
                                  )
                                },
                                expression:
                                  "webBookingHead.transportationTerms",
                              },
                            },
                            _vm._l(_vm.shippinTermList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "table-item-titel" }, [
                        _vm._v(
                          "\n                  Shipping Mode:\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "80%" },
                              attrs: {
                                disabled: _vm.detialType == "Preview",
                                placeholder: "",
                              },
                              model: {
                                value: _vm.webBookingHead.bookingType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.webBookingHead,
                                    "bookingType",
                                    $$v
                                  )
                                },
                                expression: "webBookingHead.bookingType",
                              },
                            },
                            _vm._l(_vm.shippinModeList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm.detialType == "Copy"
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "20px",
                      "margin-bottom": "20px",
                      display: "flex",
                      "justify-content": "center",
                    },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            _vm.sailScheduleDialogVisible = true
                          },
                        },
                      },
                      [_vm._v(" Choose Vessel")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.detialType !== "Copy"
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-bottom": "10px",
                      "margin-top": "10px",
                    },
                  },
                  _vm._l(_vm.voyagesData, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: item.voyagePlanId,
                        staticStyle: { "margin-bottom": "10px" },
                      },
                      [
                        _c(
                          "table",
                          {
                            staticStyle: { "border-collapse": "collapse" },
                            attrs: {
                              align: "center",
                              width: "100%",
                              border: "1px solid rgb(204,204,204)",
                              cellpadding: "5",
                            },
                          },
                          [
                            _c("tbody", [
                              _c("tr", [
                                _c("td", { staticClass: "table-vess-green" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "booking.bookingHistroryJpDetails.VESSELVOYAGE"
                                        )
                                      ) +
                                      "\n                  "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        title:
                                          item.vesselName +
                                          _vm.format +
                                          item.voyageNo +
                                          " " +
                                          item.voyageLeg,
                                        disabled: "",
                                      },
                                      model: {
                                        value:
                                          item.vesselName +
                                          _vm.format +
                                          item.voyageNo +
                                          " " +
                                          item.voyageLeg,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item.vesselName +
                                              _vm.format +
                                              item.voyageNo +
                                              " " +
                                              item,
                                            "voyageLeg",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "item.vesselName+format+item.voyageNo+' '+item.voyageLeg",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("td", { staticClass: "table-vess-grey" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "booking.bookingHistroryJpDetails.POLETA"
                                        )
                                      ) +
                                      "\n                  "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "datetime",
                                        format: "yyyy-MM-dd HH:mm",
                                        disabled: "",
                                        placeholder: "",
                                      },
                                      model: {
                                        value: item.polEtaHidden,
                                        callback: function ($$v) {
                                          _vm.$set(item, "polEtaHidden", $$v)
                                        },
                                        expression: "item.polEtaHidden",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("td", { staticClass: "table-vess-grey" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "booking.bookingHistroryJpDetails.POLETD"
                                        )
                                      ) +
                                      "\n                  "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "datetime",
                                        format: "yyyy-MM-dd HH:mm",
                                        disabled: "",
                                        placeholder: "",
                                      },
                                      model: {
                                        value: item.etd,
                                        callback: function ($$v) {
                                          _vm.$set(item, "etd", $$v)
                                        },
                                        expression: "item.etd",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("td", { staticClass: "table-vess-grey" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "booking.bookingHistroryJpDetails.PODETA"
                                        )
                                      ) +
                                      "\n                  "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "datetime",
                                        format: "yyyy-MM-dd HH:mm",
                                        disabled: "",
                                        placeholder: "",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "prefix",
                                            fn: function () {
                                              return undefined
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: item.eta,
                                        callback: function ($$v) {
                                          _vm.$set(item, "eta", $$v)
                                        },
                                        expression: "item.eta",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("tr", [
                                _c("td", { staticClass: "table-vess-green" }, [
                                  _vm._v(
                                    "\n                    Trip No:\n                  "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: item.tripNumber,
                                        callback: function ($$v) {
                                          _vm.$set(item, "tripNumber", $$v)
                                        },
                                        expression: "item.tripNumber",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("td", { staticClass: "table-vess-grey" }, [
                                  _vm._v(
                                    "\n                    Port From:\n                  "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: item.polHidden,
                                        callback: function ($$v) {
                                          _vm.$set(item, "polHidden", $$v)
                                        },
                                        expression: "item.polHidden",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("td", { staticClass: "table-vess-grey" }, [
                                  _vm._v(
                                    "\n                    Port To:\n                  "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value: item.podHidden,
                                        callback: function ($$v) {
                                          _vm.$set(item, "podHidden", $$v)
                                        },
                                        expression: "item.podHidden",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isOtherVoyage
              ? _c(
                  "div",
                  _vm._l(_vm.voyagesData, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: item.voyagePlanId,
                        staticStyle: { "margin-bottom": "10px" },
                      },
                      [
                        _c(
                          "table",
                          {
                            staticStyle: { "border-collapse": "collapse" },
                            attrs: {
                              align: "center",
                              width: "100%",
                              border: "1px solid rgb(204,204,204)",
                              cellpadding: "5",
                            },
                          },
                          [
                            _c("tbody", [
                              _c("tr", [
                                _c("td", { staticClass: "table-vess-green" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "booking.bookingHistroryJpDetails.VESSELVOYAGE"
                                        )
                                      ) +
                                      "\n                  "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  [
                                    _c("el-input", {
                                      attrs: { disabled: "" },
                                      model: {
                                        value:
                                          item.vesselName +
                                          _vm.format +
                                          item.voyageNo +
                                          " " +
                                          item.voyageLeg,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item.vesselName +
                                              _vm.format +
                                              item.voyageNo +
                                              " " +
                                              item,
                                            "voyageLeg",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "item.vesselName+format+item.voyageNo+' '+item.voyageLeg",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("td", { staticClass: "table-vess-grey" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "booking.bookingHistroryJpDetails.POLETA"
                                        )
                                      ) +
                                      "\n                  "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "datetime",
                                        format: "yyyy-MM-dd HH:mm",
                                        disabled: "",
                                        placeholder: "",
                                      },
                                      model: {
                                        value: item.polEtaHidden,
                                        callback: function ($$v) {
                                          _vm.$set(item, "polEtaHidden", $$v)
                                        },
                                        expression: "item.polEtaHidden",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("td", { staticClass: "table-vess-grey" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "booking.bookingHistroryJpDetails.POLETD"
                                        )
                                      ) +
                                      "\n                  "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "datetime",
                                        format: "yyyy-MM-dd HH:mm",
                                        disabled: "",
                                        placeholder: "",
                                      },
                                      model: {
                                        value: item.etd,
                                        callback: function ($$v) {
                                          _vm.$set(item, "etd", $$v)
                                        },
                                        expression: "item.etd",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("td", { staticClass: "table-vess-grey" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "booking.bookingHistroryJpDetails.PODETA"
                                        )
                                      ) +
                                      "\n                  "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "datetime",
                                        format: "yyyy-MM-dd HH:mm",
                                        disabled: "",
                                        placeholder: "",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "prefix",
                                            fn: function () {
                                              return undefined
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: item.eta,
                                        callback: function ($$v) {
                                          _vm.$set(item, "eta", $$v)
                                        },
                                        expression: "item.eta",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.webBookingHead.tsFlag !== "0"
                                ? _c("tr", [
                                    _c(
                                      "td",
                                      { staticClass: "table-vess-green" },
                                      [
                                        _vm._v(
                                          "\n                    Trip No:\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      [
                                        _c("el-input", {
                                          attrs: { disabled: "" },
                                          model: {
                                            value: item.tripNumber,
                                            callback: function ($$v) {
                                              _vm.$set(item, "tripNumber", $$v)
                                            },
                                            expression: "item.tripNumber",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "table-vess-grey" },
                                      [
                                        _vm._v(
                                          "\n                    Port From:\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      [
                                        _c("el-input", {
                                          attrs: { disabled: "" },
                                          model: {
                                            value: item.polHidden,
                                            callback: function ($$v) {
                                              _vm.$set(item, "polHidden", $$v)
                                            },
                                            expression: "item.polHidden",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "table-vess-grey" },
                                      [
                                        _vm._v(
                                          "\n                    Port To:\n                  "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      [
                                        _c("el-input", {
                                          attrs: { disabled: "" },
                                          model: {
                                            value: item.podHidden,
                                            callback: function ($$v) {
                                              _vm.$set(item, "podHidden", $$v)
                                            },
                                            expression: "item.podHidden",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _c(
                "table",
                {
                  staticStyle: { "border-collapse": "collapse" },
                  attrs: {
                    align: "center",
                    width: "100%",
                    border: "1px solid rgb(204,204,204)",
                    cellpadding: "15 10",
                  },
                },
                [
                  _c("tbody", [
                    _c("tr", [
                      _c("td", { staticClass: "table-item-titel" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              _vm.$t("booking.bookingHistroryJpDetails.Shipper")
                            ) +
                            "\n                  "
                        ),
                        _c("span", { staticClass: "table-item-red" }, [
                          _vm._v(
                            "\n                    ※\n                   "
                          ),
                        ]),
                        _vm._v("\n                  :\n                "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { attrs: { colspan: "2" } },
                        [
                          _c("gl-port-simis", {
                            attrs: { disabled: _vm.detialType == "Preview" },
                            on: { change: _vm.customerSelectChange },
                            model: {
                              value:
                                _vm.webBookingHead.webBkCustomers[0]
                                  .customerName,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.webBookingHead.webBkCustomers[0],
                                  "customerName",
                                  $$v
                                )
                              },
                              expression:
                                "webBookingHead.webBkCustomers[0].customerName",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c(
                        "td",
                        {
                          staticClass: "table-item-titel",
                          attrs: { rowspan: "6" },
                        },
                        [
                          _vm._v(
                            "\n                  Broker：\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("el-input", {
                            directives: [
                              {
                                name: "byte-length",
                                rawName: "v-byte-length",
                                value: 100,
                                expression: "100",
                              },
                              { name: "trim", rawName: "v-trim" },
                              { name: "fth", rawName: "v-fth" },
                            ],
                            attrs: { disabled: _vm.detialType == "Preview" },
                            model: {
                              value:
                                _vm.webBookingHead.webBkExtends[0]
                                  .customsBroker,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.webBookingHead.webBkExtends[0],
                                  "customsBroker",
                                  $$v
                                )
                              },
                              expression:
                                "webBookingHead.webBkExtends[0].customsBroker",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("el-input", {
                            directives: [
                              {
                                name: "byte-length",
                                rawName: "v-byte-length",
                                value: 100,
                                expression: "100",
                              },
                              { name: "trim", rawName: "v-trim" },
                              { name: "fth", rawName: "v-fth" },
                            ],
                            attrs: { disabled: _vm.detialType == "Preview" },
                            model: {
                              value:
                                _vm.webBookingHead.webBkExtends[0]
                                  .brokerContacts,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.webBookingHead.webBkExtends[0],
                                  "brokerContacts",
                                  $$v
                                )
                              },
                              expression:
                                "webBookingHead.webBkExtends[0].brokerContacts",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("el-input", {
                            directives: [
                              {
                                name: "byte-length",
                                rawName: "v-byte-length",
                                value: 30,
                                expression: "30",
                              },
                              { name: "trim", rawName: "v-trim" },
                              { name: "fth", rawName: "v-fth" },
                            ],
                            attrs: { disabled: _vm.detialType == "Preview" },
                            model: {
                              value:
                                _vm.webBookingHead.webBkExtends[0].brokerTel,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.webBookingHead.webBkExtends[0],
                                  "brokerTel",
                                  $$v
                                )
                              },
                              expression:
                                "webBookingHead.webBkExtends[0].brokerTel",
                            },
                          }),
                          _vm._v(" "),
                          _vm._m(3),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "table-td-second" }, [
                        _c(
                          "span",
                          { staticStyle: { "margin-right": "10px" } },
                          [
                            _c("el-checkbox", {
                              attrs: {
                                disabled: _vm.detialType == "Preview",
                                "true-label": 1,
                                "false-label": 0,
                              },
                              model: {
                                value:
                                  _vm.webBookingHead.webBkExtends[0]
                                    .isSendBrokerFax,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.webBookingHead.webBkExtends[0],
                                    "isSendBrokerFax",
                                    $$v
                                  )
                                },
                                expression:
                                  "webBookingHead.webBkExtends[0].isSendBrokerFax",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v("\n                  Fax ※\n                  "),
                        _c("br"),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "\n                  (フレートメモ送付用)\n                  "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("el-input", {
                            directives: [
                              {
                                name: "byte-length",
                                rawName: "v-byte-length",
                                value: 20,
                                expression: "20",
                              },
                              { name: "trim", rawName: "v-trim" },
                              { name: "fth", rawName: "v-fth" },
                            ],
                            attrs: { disabled: _vm.detialType == "Preview" },
                            model: {
                              value:
                                _vm.webBookingHead.webBkExtends[0].brokerFax,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.webBookingHead.webBkExtends[0],
                                  "brokerFax",
                                  $$v
                                )
                              },
                              expression:
                                "webBookingHead.webBkExtends[0].brokerFax",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "table-td-second" }, [
                        _c(
                          "span",
                          { staticStyle: { "margin-right": "10px" } },
                          [
                            _c("el-checkbox", {
                              attrs: {
                                disabled: _vm.detialType == "Preview",
                                "true-label": 1,
                                "false-label": 0,
                              },
                              model: {
                                value:
                                  _vm.webBookingHead.webBkExtends[0]
                                    .isSendBrokerEmail,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.webBookingHead.webBkExtends[0],
                                    "isSendBrokerEmail",
                                    $$v
                                  )
                                },
                                expression:
                                  "webBookingHead.webBkExtends[0].isSendBrokerEmail",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(
                          "\n                  E-mail ※\n                  "
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "\n                  (フレートメモ送付用)\n                  "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("el-input", {
                            directives: [
                              {
                                name: "byte-length",
                                rawName: "v-byte-length",
                                value: 500,
                                expression: "500",
                              },
                              { name: "trim", rawName: "v-trim" },
                              { name: "fth", rawName: "v-fth" },
                            ],
                            attrs: { disabled: _vm.detialType == "Preview" },
                            model: {
                              value:
                                _vm.webBookingHead.webBkExtends[0].brokerEmail,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.webBookingHead.webBkExtends[0],
                                  "brokerEmail",
                                  $$v
                                )
                              },
                              expression:
                                "webBookingHead.webBkExtends[0].brokerEmail",
                            },
                          }),
                          _vm._v(" "),
                          _vm._m(4),
                          _vm._v(" "),
                          _c("p"),
                          _vm._v(" "),
                          _vm._m(5),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("tr"),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "table-item-titel" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              _vm.$t("booking.bookingHistroryJpDetails.Volume")
                            ) +
                            "\n                  "
                        ),
                        _c("span", { staticClass: "table-item-red" }, [
                          _vm._v(
                            "\n                    ※\n                   "
                          ),
                        ]),
                        _vm._v("\n                  :\n                "),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v("\n                  FCL\n                "),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "div",
                          [
                            _vm._v(
                              "\n                    Gross Weight(kg):\n                    "
                            ),
                            _c("el-input-number", {
                              staticStyle: { width: "150px" },
                              attrs: {
                                precision: 1,
                                max: 99999999999.999,
                                disabled: _vm.detialType == "Preview",
                              },
                              model: {
                                value:
                                  _vm.webBookingHead.webBkCargos[0].grossWeight,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.webBookingHead.webBkCargos[0],
                                    "grossWeight",
                                    $$v
                                  )
                                },
                                expression:
                                  "webBookingHead.webBkCargos[0].grossWeight",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "table-item-red" }, [
                              _c("span", [
                                _vm._v(
                                  "\n                        (\n                      "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "\n                         " +
                                    _vm._s(
                                      _vm.detialType !== "Copy"
                                        ? "Exclude"
                                        : "Include"
                                    ) +
                                    "\n                      "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  "\n                         Tare Weight)\n                      "
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { attrs: { STYLE: "margin-bottom: 10px" } },
                          [
                            _vm.detialType !== "Preview"
                              ? _c("el-button", {
                                  attrs: {
                                    type: "primary",
                                    icon: "el-icon-plus",
                                  },
                                  on: { click: _vm.addWebBkPreContainers },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.detialType !== "Preview"
                              ? _c("el-button", {
                                  attrs: {
                                    type: "primary",
                                    icon: "el-icon-minus",
                                  },
                                  on: { click: _vm.deleteWebBkPreContainers },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "table-item-red",
                                staticStyle: {
                                  display: "inline-block",
                                  margin: "0 40px",
                                },
                              },
                              [
                                _vm._v(
                                  "\n                      Click here to add or subtract container type.\n                  "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.detialType !== "Preview" &&
                            _vm.detialType !== "Copy"
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.getOpenPaegContact },
                                  },
                                  [_vm._v("Container Type Detail")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "div",
                            { staticClass: "table-container-new" },
                            [
                              _c(
                                "el-table",
                                {
                                  ref: "webBkPreContainersTableRef",
                                  attrs: {
                                    data: _vm.webBookingHead.webBkPreContainers,
                                    "cell-class-name":
                                      _vm.cellClassNameWebBkPreContainers,
                                    "highlight-current-row": "",
                                  },
                                  on: {
                                    "cell-click":
                                      _vm.cellClickWebBkPreContainers,
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: { label: "Size", align: "center" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: {
                                                  width: "80%!important",
                                                },
                                                attrs: {
                                                  filterable: "",
                                                  placeholder: "",
                                                  disabled:
                                                    _vm.detialType == "Preview",
                                                },
                                                model: {
                                                  value:
                                                    scope.row.containerType,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "containerType",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.containerType",
                                                },
                                              },
                                              _vm._l(
                                                _vm.sizeList,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item,
                                                    attrs: {
                                                      label: item,
                                                      value: item,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "Quantity",
                                      align: "center",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c("el-input-number", {
                                              staticStyle: { width: "80%" },
                                              attrs: {
                                                precision: 0,
                                                min: 0,
                                                max: 999999999,
                                                disabled:
                                                  _vm.detialType == "Preview",
                                              },
                                              model: {
                                                value: scope.row.quantity,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "quantity",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.quantity",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "Cargo Group",
                                      align: "center",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-select",
                                              {
                                                staticStyle: {
                                                  width: "80%!important",
                                                },
                                                attrs: {
                                                  filterable: "",
                                                  placeholder: "",
                                                  disabled:
                                                    _vm.detialType == "Preview",
                                                },
                                                model: {
                                                  value:
                                                    scope.row.commodityCode,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "commodityCode",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.commodityCode",
                                                },
                                              },
                                              _vm._l(
                                                _vm.cargoGroupList,
                                                function (item) {
                                                  return _c("el-option", {
                                                    key: item.value,
                                                    attrs: {
                                                      label: item.label,
                                                      value: item.value,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _vm._m(6),
                      _vm._v(" "),
                      _c(
                        "td",
                        { attrs: { colspan: "2" } },
                        [
                          _c("el-input", {
                            directives: [
                              {
                                name: "byte-length",
                                rawName: "v-byte-length",
                                value: 4000,
                                expression: "4000",
                              },
                              { name: "trim", rawName: "v-trim" },
                              { name: "fth", rawName: "v-fth" },
                            ],
                            attrs: { disabled: _vm.detialType == "Preview" },
                            model: {
                              value:
                                _vm.webBookingHead.webBkCargos[0].cargoDesc,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.webBookingHead.webBkCargos[0],
                                  "cargoDesc",
                                  $$v
                                )
                              },
                              expression:
                                "webBookingHead.webBkCargos[0].cargoDesc",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c(
                        "td",
                        { staticClass: "table-item-titel" },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.$t(
                                  "booking.bookingHistroryJpDetails.HazardousCargo"
                                )
                              ) +
                              "\n                  "
                          ),
                          _c(
                            "span",
                            {
                              staticStyle: { position: "absolute", right: "0" },
                            },
                            [
                              _c("el-checkbox", {
                                staticStyle: { "margin-right": "20px" },
                                attrs: {
                                  disabled: _vm.detialType == "Preview",
                                  "true-label": 1,
                                  "false-label": 0,
                                },
                                on: { change: _vm.dangerCheckboxChange },
                                model: {
                                  value: _vm.webBookingHead.dgCheckFlag,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.webBookingHead,
                                      "dgCheckFlag",
                                      $$v
                                    )
                                  },
                                  expression: "webBookingHead.dgCheckFlag",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.detialType !== "Preview" &&
                          _vm.detialType !== "Copy"
                            ? _c(
                                "el-button",
                                {
                                  staticStyle: {
                                    display: "block",
                                    padding: "10px 5px",
                                    width: "135px",
                                    margin: "10px -5px 0px",
                                  },
                                  attrs: { type: "primary" },
                                  on: { click: _vm.getOpenPaegDgList },
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "booking.bookingHistroryJpDetails.DGList"
                                        )
                                      ) +
                                      "\n                  "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", { attrs: { colspan: "2" } }, [
                        _vm.webBookingHead.dgCheckFlag == "1"
                          ? _c("div", [
                              _c(
                                "div",
                                { attrs: { STYLE: "margin-bottom: 10px" } },
                                [
                                  _vm.detialType !== "Preview"
                                    ? _c("el-button", {
                                        attrs: {
                                          type: "primary",
                                          icon: "el-icon-plus",
                                        },
                                        on: { click: _vm.addWebBkImos },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.detialType !== "Preview"
                                    ? _c("el-button", {
                                        attrs: {
                                          type: "primary",
                                          icon: "el-icon-minus",
                                        },
                                        on: { click: _vm.deleteWebBkImos },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: { overflow: "auto" },
                                  style: {
                                    width: _vm.autoTrWidth - 180 + "px",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "table-container-new" },
                                    [
                                      _c(
                                        "el-table",
                                        {
                                          ref: "webBkAksRef",
                                          staticStyle: {
                                            width: "max-content",
                                            "max-width": "max-content",
                                          },
                                          attrs: {
                                            data: _vm.webBookingHead
                                              .webBkCargos[0].webBkImos,
                                            "cell-class-name":
                                              _vm.cellClassNameWebBkImos,
                                          },
                                          on: {
                                            "cell-click":
                                              _vm.cellClickWebBkImos,
                                          },
                                        },
                                        [
                                          _c("el-table-column", {
                                            attrs: {
                                              label: "No",
                                              width: "45",
                                              align: "center",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _vm._v(
                                                        "\n                              " +
                                                          _vm._s(
                                                            scope.$index + 1
                                                          ) +
                                                          "\n                            "
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              825508505
                                            ),
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                width: "105",
                                                align: "center",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c("el-input", {
                                                          directives: [
                                                            {
                                                              name: "byte-length",
                                                              rawName:
                                                                "v-byte-length",
                                                              value: 20,
                                                              expression: "20",
                                                            },
                                                            {
                                                              name: "trim",
                                                              rawName: "v-trim",
                                                            },
                                                            {
                                                              name: "fth",
                                                              rawName: "v-fth",
                                                            },
                                                          ],
                                                          staticStyle: {
                                                            width: "80%",
                                                          },
                                                          attrs: {
                                                            disabled:
                                                              _vm.detialType ==
                                                              "Preview",
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row
                                                                .classType,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "classType",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.classType",
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                4209936241
                                              ),
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "header" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                    },
                                                    [_vm._v(" *")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                    },
                                                    [_vm._v("IMO Class")]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                width: "105",
                                                align: "center",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c("el-input", {
                                                          directives: [
                                                            {
                                                              name: "byte-length",
                                                              rawName:
                                                                "v-byte-length",
                                                              value: 50,
                                                              expression: "50",
                                                            },
                                                            {
                                                              name: "trim",
                                                              rawName: "v-trim",
                                                            },
                                                            {
                                                              name: "fth",
                                                              rawName: "v-fth",
                                                            },
                                                          ],
                                                          attrs: {
                                                            disabled:
                                                              _vm.detialType ==
                                                              "Preview",
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row
                                                                .unSeriseNo,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "unSeriseNo",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.unSeriseNo",
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                3428540552
                                              ),
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "header" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                    },
                                                    [_vm._v(" *")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                    },
                                                    [_vm._v("UN NO.")]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: "Sub Label (If any)",
                                              width: "100",
                                              align: "center",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("el-input", {
                                                        directives: [
                                                          {
                                                            name: "byte-length",
                                                            rawName:
                                                              "v-byte-length",
                                                            value: 100,
                                                            expression: "100",
                                                          },
                                                          {
                                                            name: "trim",
                                                            rawName: "v-trim",
                                                          },
                                                          {
                                                            name: "fth",
                                                            rawName: "v-fth",
                                                          },
                                                        ],
                                                        attrs: {
                                                          disabled:
                                                            _vm.detialType ==
                                                            "Preview",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row.label,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "label",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.label",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              2613247951
                                            ),
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                width: "105",
                                                align: "center",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c("el-input", {
                                                          directives: [
                                                            {
                                                              name: "byte-length",
                                                              rawName:
                                                                "v-byte-length",
                                                              value: 10,
                                                              expression: "10",
                                                            },
                                                            {
                                                              name: "trim",
                                                              rawName: "v-trim",
                                                            },
                                                            {
                                                              name: "fth",
                                                              rawName: "v-fth",
                                                            },
                                                          ],
                                                          attrs: {
                                                            disabled:
                                                              _vm.detialType ==
                                                              "Preview",
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row
                                                                .quantity,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "quantity",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.quantity",
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                1954143666
                                              ),
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "header" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                    },
                                                    [_vm._v(" *")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                    },
                                                    [_vm._v("Quantity")]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                width: "105",
                                                align: "center",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            staticStyle: {
                                                              width: "80%",
                                                            },
                                                            attrs: {
                                                              disabled:
                                                                _vm.detialType ==
                                                                "Preview",
                                                              placeholder: "",
                                                            },
                                                            model: {
                                                              value:
                                                                scope.row
                                                                  .packageDesc,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    scope.row,
                                                                    "packageDesc",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "scope.row.packageDesc",
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.packageDescList,
                                                            function (item) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  key: item.value,
                                                                  attrs: {
                                                                    label:
                                                                      item.label,
                                                                    value:
                                                                      item.value,
                                                                  },
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                2461561298
                                              ),
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "header" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                    },
                                                    [_vm._v(" *")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                    },
                                                    [_vm._v("Package Group")]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                width: "105",
                                                align: "center",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            staticStyle: {
                                                              width: "80%",
                                                            },
                                                            attrs: {
                                                              disabled:
                                                                _vm.detialType ==
                                                                "Preview",
                                                              placeholder: "",
                                                            },
                                                            model: {
                                                              value:
                                                                scope.row
                                                                  .packageCode,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    scope.row,
                                                                    "packageCode",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "scope.row.packageCode",
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.packageTypeList,
                                                            function (item) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  key: item.code,
                                                                  attrs: {
                                                                    label:
                                                                      item.name,
                                                                    value:
                                                                      item.code,
                                                                  },
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                3332586246
                                              ),
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "header" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                    },
                                                    [_vm._v(" *")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                    },
                                                    [_vm._v("Type of Packing")]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                width: "105",
                                                align: "center",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c("el-input", {
                                                          directives: [
                                                            {
                                                              name: "byte-length",
                                                              rawName:
                                                                "v-byte-length",
                                                              value: 8,
                                                              expression: "8",
                                                            },
                                                            {
                                                              name: "trim",
                                                              rawName: "v-trim",
                                                            },
                                                            {
                                                              name: "fth",
                                                              rawName: "v-fth",
                                                            },
                                                          ],
                                                          attrs: {
                                                            disabled:
                                                              _vm.detialType ==
                                                              "Preview",
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row
                                                                .grossWeight,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "grossWeight",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.grossWeight",
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                3709934451
                                              ),
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "header" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                    },
                                                    [_vm._v(" *")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                    },
                                                    [_vm._v("Gross Weight")]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                width: "105",
                                                align: "center",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c("el-input", {
                                                          directives: [
                                                            {
                                                              name: "byte-length",
                                                              rawName:
                                                                "v-byte-length",
                                                              value: 8,
                                                              expression: "8",
                                                            },
                                                            {
                                                              name: "trim",
                                                              rawName: "v-trim",
                                                            },
                                                            {
                                                              name: "fth",
                                                              rawName: "v-fth",
                                                            },
                                                          ],
                                                          attrs: {
                                                            disabled:
                                                              _vm.detialType ==
                                                              "Preview",
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row
                                                                .netWeight,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "netWeight",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.netWeight",
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                210605526
                                              ),
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "header" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                    },
                                                    [_vm._v(" *")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                    },
                                                    [_vm._v("Net Weight")]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: "Flash Point",
                                              width: "105",
                                              align: "center",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("el-input-number", {
                                                        attrs: {
                                                          precision: 2,
                                                          "auto-cut": true,
                                                          controls: false,
                                                          max: 99999999.99,
                                                          disabled:
                                                            _vm.detialType ==
                                                            "Preview",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .flashPoint,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "flashPoint",
                                                              typeof $$v ===
                                                                "string"
                                                                ? $$v.trim()
                                                                : $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.flashPoint",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              3608999283
                                            ),
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: "Polluted",
                                              width: "105",
                                              align: "center",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("el-checkbox", {
                                                        staticStyle: {
                                                          "margin-right":
                                                            "20px",
                                                        },
                                                        attrs: {
                                                          "true-label": 1,
                                                          "false-label": 0,
                                                          disabled:
                                                            _vm.detialType ==
                                                            "Preview",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .isPolutionFlag,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "isPolutionFlag",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.isPolutionFlag",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              213944207
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-table",
                                        {
                                          ref: "webBkAksRef",
                                          staticStyle: {
                                            width: "max-content",
                                            "max-width": "max-content",
                                          },
                                          attrs: {
                                            data: _vm.webBookingHead
                                              .webBkCargos[0].webBkImos,
                                            "cell-class-name":
                                              _vm.cellClassNameWebBkImos,
                                          },
                                          on: {
                                            "cell-click":
                                              _vm.cellClickWebBkImos,
                                          },
                                        },
                                        [
                                          _c("el-table-column", {
                                            attrs: {
                                              label: "No",
                                              width: "45",
                                              align: "center",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _vm._v(
                                                        "\n                              " +
                                                          _vm._s(
                                                            scope.$index + 1
                                                          ) +
                                                          "\n                            "
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              825508505
                                            ),
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                width: "105",
                                                align: "center",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c("el-input", {
                                                          directives: [
                                                            {
                                                              name: "byte-length",
                                                              rawName:
                                                                "v-byte-length",
                                                              value: 6,
                                                              expression: "6",
                                                            },
                                                            {
                                                              name: "trim",
                                                              rawName: "v-trim",
                                                            },
                                                            {
                                                              name: "fth",
                                                              rawName: "v-fth",
                                                            },
                                                          ],
                                                          attrs: {
                                                            disabled:
                                                              _vm.detialType ==
                                                              "Preview",
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.casNo1,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "casNo1",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.casNo1",
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                1020846344
                                              ),
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "header" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                    },
                                                    [_vm._v(" *")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                    },
                                                    [_vm._v("CAS_NO1")]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                width: "105",
                                                align: "center",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c("el-input", {
                                                          directives: [
                                                            {
                                                              name: "byte-length",
                                                              rawName:
                                                                "v-byte-length",
                                                              value: 2,
                                                              expression: "2",
                                                            },
                                                            {
                                                              name: "trim",
                                                              rawName: "v-trim",
                                                            },
                                                            {
                                                              name: "fth",
                                                              rawName: "v-fth",
                                                            },
                                                          ],
                                                          attrs: {
                                                            disabled:
                                                              _vm.detialType ==
                                                              "Preview",
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.casNo2,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "casNo2",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.casNo2",
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                1794139947
                                              ),
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "header" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                    },
                                                    [_vm._v(" *")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                    },
                                                    [_vm._v("CAS_NO2")]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                width: "105",
                                                align: "center",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c("el-input", {
                                                          directives: [
                                                            {
                                                              name: "byte-length",
                                                              rawName:
                                                                "v-byte-length",
                                                              value: 1,
                                                              expression: "1",
                                                            },
                                                            {
                                                              name: "trim",
                                                              rawName: "v-trim",
                                                            },
                                                            {
                                                              name: "fth",
                                                              rawName: "v-fth",
                                                            },
                                                          ],
                                                          attrs: {
                                                            disabled:
                                                              _vm.detialType ==
                                                              "Preview",
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row.casNo3,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "casNo3",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.casNo3",
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                1251020586
                                              ),
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "header" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                    },
                                                    [_vm._v(" *")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                    },
                                                    [_vm._v("CAS_NO3")]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                width: "105",
                                                align: "center",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c("el-input", {
                                                          directives: [
                                                            {
                                                              name: "byte-length",
                                                              rawName:
                                                                "v-byte-length",
                                                              value: 10,
                                                              expression: "10",
                                                            },
                                                            {
                                                              name: "trim",
                                                              rawName: "v-trim",
                                                            },
                                                            {
                                                              name: "fth",
                                                              rawName: "v-fth",
                                                            },
                                                          ],
                                                          attrs: {
                                                            disabled:
                                                              _vm.detialType ==
                                                              "Preview",
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row
                                                                .cargoSize,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "cargoSize",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.cargoSize",
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                3827797172
                                              ),
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "header" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                    },
                                                    [_vm._v(" *")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "booking.bookingHistroryJpDetails.Size"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: _vm.$t(
                                                "booking.bookingHistroryJpDetails.Temperature"
                                              ),
                                              width: "105",
                                              align: "center",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("el-input", {
                                                        directives: [
                                                          {
                                                            name: "byte-length",
                                                            rawName:
                                                              "v-byte-length",
                                                            value: 10,
                                                            expression: "10",
                                                          },
                                                          {
                                                            name: "trim",
                                                            rawName: "v-trim",
                                                          },
                                                          {
                                                            name: "fth",
                                                            rawName: "v-fth",
                                                          },
                                                        ],
                                                        attrs: {
                                                          disabled:
                                                            _vm.detialType ==
                                                            "Preview",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .temperature,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "temperature",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.temperature",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              2526907749
                                            ),
                                          }),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: _vm.$t(
                                                "booking.bookingHistroryJpDetails.Vent"
                                              ),
                                              width: "105",
                                              align: "center",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("el-input", {
                                                        directives: [
                                                          {
                                                            name: "byte-length",
                                                            rawName:
                                                              "v-byte-length",
                                                            value: 20,
                                                            expression: "20",
                                                          },
                                                          {
                                                            name: "trim",
                                                            rawName: "v-trim",
                                                          },
                                                          {
                                                            name: "fth",
                                                            rawName: "v-fth",
                                                          },
                                                        ],
                                                        attrs: {
                                                          disabled:
                                                            _vm.detialType ==
                                                            "Preview",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row.intakeNum,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "intakeNum",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.intakeNum",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              3469224323
                                            ),
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                width: "105",
                                                align: "center",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c("el-input", {
                                                          directives: [
                                                            {
                                                              name: "byte-length",
                                                              rawName:
                                                                "v-byte-length",
                                                              value: 50,
                                                              expression: "50",
                                                            },
                                                            {
                                                              name: "trim",
                                                              rawName: "v-trim",
                                                            },
                                                            {
                                                              name: "fth",
                                                              rawName: "v-fth",
                                                            },
                                                          ],
                                                          attrs: {
                                                            disabled:
                                                              _vm.detialType ==
                                                              "Preview",
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row
                                                                .contactName,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "contactName",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.contactName",
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                3104616814
                                              ),
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "header" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                    },
                                                    [_vm._v(" *")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "booking.bookingHistroryJpDetails.ContactName"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                width: "105",
                                                align: "center",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c("el-input", {
                                                          directives: [
                                                            {
                                                              name: "byte-length",
                                                              rawName:
                                                                "v-byte-length",
                                                              value: 50,
                                                              expression: "50",
                                                            },
                                                            {
                                                              name: "trim",
                                                              rawName: "v-trim",
                                                            },
                                                            {
                                                              name: "fth",
                                                              rawName: "v-fth",
                                                            },
                                                          ],
                                                          attrs: {
                                                            disabled:
                                                              _vm.detialType ==
                                                              "Preview",
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row
                                                                .contactNumber,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "contactNumber",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.contactNumber",
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                452110858
                                              ),
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "header" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                    },
                                                    [_vm._v(" *")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "booking.bookingHistroryJpDetails.ContactNumber"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                width: "115",
                                                align: "center",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            staticStyle: {
                                                              width: "80%",
                                                            },
                                                            attrs: {
                                                              disabled:
                                                                _vm.detialType ==
                                                                "Preview",
                                                              placeholder: "",
                                                            },
                                                            model: {
                                                              value:
                                                                scope.row
                                                                  .contactTypeCode,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    scope.row,
                                                                    "contactTypeCode",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "scope.row.contactTypeCode",
                                                            },
                                                          },
                                                          _vm._l(
                                                            _vm.contactTypeCodeList,
                                                            function (item) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  key: item.value,
                                                                  attrs: {
                                                                    label:
                                                                      item.label,
                                                                    value:
                                                                      item.value,
                                                                  },
                                                                }
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                877544210
                                              ),
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "header" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                    },
                                                    [_vm._v(" *")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "booking.bookingHistroryJpDetails.ContactTypeCode"
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c("el-table-column", {
                                            attrs: {
                                              label: _vm.$t(
                                                "booking.bookingHistroryJpDetails.ApproveKey"
                                              ),
                                              width: "105",
                                              align: "center",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("el-input", {
                                                        directives: [
                                                          {
                                                            name: "byte-length",
                                                            rawName:
                                                              "v-byte-length",
                                                            value: 10,
                                                            expression: "10",
                                                          },
                                                          {
                                                            name: "trim",
                                                            rawName: "v-trim",
                                                          },
                                                          {
                                                            name: "fth",
                                                            rawName: "v-fth",
                                                          },
                                                        ],
                                                        attrs: {
                                                          disabled:
                                                            _vm.detialType ==
                                                            "Preview",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .approveKey,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "approveKey",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.approveKey",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              2095972593
                                            ),
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-table",
                                        {
                                          ref: "webBkPreContainersTableRef",
                                          staticStyle: { "margin-top": "10px" },
                                          attrs: {
                                            data: _vm.webBookingHead
                                              .webBkCargos[0].webBkImos,
                                            "cell-class-name":
                                              _vm.cellClassNameWebBkPreContainers,
                                          },
                                          on: {
                                            "cell-click":
                                              _vm.cellClickWebBkPreContainers,
                                          },
                                        },
                                        [
                                          _c("el-table-column", {
                                            attrs: { label: "No", width: "45" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _vm._v(
                                                        "\n                              " +
                                                          _vm._s(
                                                            scope.$index + 1
                                                          ) +
                                                          "\n                            "
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              825508505
                                            ),
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "el-table-column",
                                            {
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c("el-input", {
                                                          directives: [
                                                            {
                                                              name: "byte-length",
                                                              rawName:
                                                                "v-byte-length",
                                                              value: 500,
                                                              expression: "500",
                                                            },
                                                            {
                                                              name: "trim",
                                                              rawName: "v-trim",
                                                            },
                                                            {
                                                              name: "fth",
                                                              rawName: "v-fth",
                                                            },
                                                          ],
                                                          attrs: {
                                                            disabled:
                                                              _vm.detialType ==
                                                              "Preview",
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row
                                                                .property,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "property",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.property",
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                3707635822
                                              ),
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "header" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "text-align": "center",
                                                        color: "#B7410E",
                                                        "line-height": "16px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Shipping Name / 貨物名"
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                      staticStyle: {
                                                        "text-align": "center",
                                                        "margin-top": "6px",
                                                        "line-height": "16px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Example:FLAMMABLE LIQUID, CORROSIVE LIQUID"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-table-column",
                                            {
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c("el-input", {
                                                          directives: [
                                                            {
                                                              name: "byte-length",
                                                              rawName:
                                                                "v-byte-length",
                                                              value: 200,
                                                              expression: "200",
                                                            },
                                                            {
                                                              name: "trim",
                                                              rawName: "v-trim",
                                                            },
                                                            {
                                                              name: "fth",
                                                              rawName: "v-fth",
                                                            },
                                                          ],
                                                          attrs: {
                                                            disabled:
                                                              _vm.detialType ==
                                                              "Preview",
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row
                                                                .componentDesc,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "componentDesc",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.componentDesc",
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                3667435223
                                              ),
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "header" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "text-align": "center",
                                                        color: "#B7410E",
                                                        "line-height": "16px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Chemical Name/ 化学名"
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                      staticStyle: {
                                                        "text-align": "center",
                                                        "margin-top": "6px",
                                                        "line-height": "16px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Example:Isopropyl Alcohol, sodium silicate"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-table",
                                        {
                                          ref: "webBkPreContainersTableRef",
                                          staticStyle: { "margin-top": "10px" },
                                          attrs: {
                                            data: _vm.emergencyTelNoData,
                                          },
                                        },
                                        [
                                          _c(
                                            "el-table-column",
                                            {
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (scope) {
                                                      return [
                                                        _c("el-input", {
                                                          directives: [
                                                            {
                                                              name: "byte-length",
                                                              rawName:
                                                                "v-byte-length",
                                                              value: 100,
                                                              expression: "100",
                                                            },
                                                            {
                                                              name: "trim",
                                                              rawName: "v-trim",
                                                            },
                                                            {
                                                              name: "fth",
                                                              rawName: "v-fth",
                                                            },
                                                          ],
                                                          attrs: {
                                                            disabled:
                                                              _vm.detialType ==
                                                              "Preview",
                                                          },
                                                          model: {
                                                            value:
                                                              scope.row
                                                                .emergencyTelNo,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope.row,
                                                                "emergencyTelNo",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope.row.emergencyTelNo",
                                                          },
                                                        }),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                2140268892
                                              ),
                                            },
                                            [
                                              _c(
                                                "template",
                                                { slot: "header" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "text-align": "center",
                                                        color: "#B7410E",
                                                        "line-height": "16px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Consignee's Company Name, PIC and Contact way / Consigneeの会社名・担当者名・連絡先"
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "required-marker",
                                                      staticStyle: {
                                                        "text-align": "center",
                                                        "margin-top": "6px",
                                                        "line-height": "16px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "Please input Consignee's mobile phone no. if possile / 可能でしたらConsigneeの携帯番号を記載願います。"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "table-item-red",
                                      staticStyle: {
                                        "margin-top": "20px",
                                        "margin-bottom": "10px",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                        " +
                                          _vm._s(
                                            _vm.$t(
                                              "booking.bookingHistroryJpDetails.dangerInfoTips"
                                            )
                                          ) +
                                          "\n                      "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "table-item-red",
                                      staticStyle: { "margin-bottom": "10px" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                        For example 1 : 20GPx1 CLASS 9 / UN 1993\n                      "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "table-item-red",
                                      staticStyle: { "margin-bottom": "10px" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                                 \n                        40GPx1 CLASS 9 / UN 1993, CLASS 8 / UN 1770\n                      "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "table-item-red",
                                      staticStyle: { "margin-bottom": "10px" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                        For example 2 : 20GPx1, 40GPx1 CLASS 9 / UN 1993\n                      "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ])
                          : _c("div", [
                              _c("div", {
                                style: { width: _vm.autoTrWidth - 180 + "px" },
                              }),
                            ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "table-item-titel" }, [
                        _vm._v("\n                  SOC：\n                  "),
                        _c(
                          "span",
                          { staticStyle: { position: "absolute", right: "0" } },
                          [
                            _c("el-checkbox", {
                              staticStyle: { "margin-right": "20px" },
                              attrs: {
                                "true-label": 1,
                                "false-label": 0,
                                disabled: _vm.detialType == "Preview",
                              },
                              model: {
                                value: _vm.webBookingHead.socCheckFlag,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.webBookingHead,
                                    "socCheckFlag",
                                    $$v
                                  )
                                },
                                expression: "webBookingHead.socCheckFlag",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { colspan: "2" } }),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "table-item-titel" }, [
                        _vm._v(
                          "\n                  Waste Paper：\n                  "
                        ),
                        _c(
                          "span",
                          { staticStyle: { position: "absolute", right: "0" } },
                          [
                            _c("el-checkbox", {
                              staticStyle: { "margin-right": "20px" },
                              attrs: {
                                "true-label": 1,
                                "false-label": 0,
                                disabled: _vm.detialType == "Preview",
                              },
                              model: {
                                value: _vm.webBookingHead.wpCheckFlag,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.webBookingHead,
                                    "wpCheckFlag",
                                    $$v
                                  )
                                },
                                expression: "webBookingHead.wpCheckFlag",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { colspan: "2" } }),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "table-item-titel" }, [
                        _vm._v(
                          "\n                  Reefer：\n                  "
                        ),
                        _c(
                          "span",
                          { staticStyle: { position: "absolute", right: "0" } },
                          [
                            _c("el-checkbox", {
                              staticStyle: { "margin-right": "20px" },
                              attrs: {
                                "true-label": 1,
                                "false-label": 0,
                                disabled: _vm.detialType == "Preview",
                              },
                              on: { change: _vm.reeferCheckboxChange },
                              model: {
                                value: _vm.webBookingHead.rfCheckFlag,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.webBookingHead,
                                    "rfCheckFlag",
                                    $$v
                                  )
                                },
                                expression: "webBookingHead.rfCheckFlag",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { colspan: "2" } }, [
                        _vm.webBookingHead.rfCheckFlag == "1"
                          ? _c("div", [
                              _c(
                                "div",
                                { attrs: { STYLE: "margin-bottom: 10px" } },
                                [
                                  _vm.detialType !== "Preview"
                                    ? _c("el-button", {
                                        attrs: {
                                          type: "primary",
                                          icon: "el-icon-plus",
                                        },
                                        on: { click: _vm.addWebBkReefers },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.detialType !== "Preview"
                                    ? _c("el-button", {
                                        attrs: {
                                          type: "primary",
                                          icon: "el-icon-minus",
                                        },
                                        on: { click: _vm.deleteWebBkReefers },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "table-container-new" },
                                [
                                  _c(
                                    "el-table",
                                    {
                                      ref: "webBkPreContainersTableRef",
                                      attrs: {
                                        data: _vm.webBookingHead.webBkCargos[0]
                                          .webBkReefers,
                                        "cell-class-name":
                                          _vm.cellClassNameWebBkReefers,
                                        "highlight-current-row": "",
                                      },
                                      on: {
                                        "cell-click": _vm.cellClickWebBkReefers,
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "Unit",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      staticStyle: {
                                                        width: "80%!important",
                                                      },
                                                      attrs: {
                                                        placeholder: "",
                                                        disabled:
                                                          _vm.detialType ==
                                                          "Preview",
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.rateBase,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "rateBase",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.rateBase",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.unitList,
                                                      function (item) {
                                                        return _c("el-option", {
                                                          key: item.value,
                                                          attrs: {
                                                            label: item.label,
                                                            value: item.value,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3776952836
                                        ),
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "Temperature",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-input", {
                                                    directives: [
                                                      {
                                                        name: "byte-length",
                                                        rawName:
                                                          "v-byte-length",
                                                        value: 10,
                                                        expression: "10",
                                                      },
                                                      {
                                                        name: "trim",
                                                        rawName: "v-trim",
                                                      },
                                                      {
                                                        name: "fth",
                                                        rawName: "v-fth",
                                                      },
                                                    ],
                                                    staticStyle: {
                                                      width: "80%",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        _vm.detialType ==
                                                        "Preview",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.temperature,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "temperature",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.temperature",
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3914383307
                                        ),
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "Pre-cool",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      staticStyle: {
                                                        width: "80%!important",
                                                      },
                                                      attrs: {
                                                        placeholder: "",
                                                        disabled:
                                                          _vm.detialType ==
                                                          "Preview",
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.preCool,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "preCool",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.preCool",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.preCoolList,
                                                      function (item) {
                                                        return _c("el-option", {
                                                          key: item.value,
                                                          attrs: {
                                                            label: item.label,
                                                            value: item.value,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          902952757
                                        ),
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "Vent",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      staticStyle: {
                                                        width: "80%!important",
                                                      },
                                                      attrs: {
                                                        placeholder: "",
                                                        disabled:
                                                          _vm.detialType ==
                                                          "Preview",
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.intakeNum,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "intakeNum",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.intakeNum",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.ventList,
                                                      function (item) {
                                                        return _c("el-option", {
                                                          key: item.value,
                                                          attrs: {
                                                            label: item.label,
                                                            value: item.value,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1702135062
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  !_vm.validateNull(
                                    _vm.webBookingHead.webBkCargos[0].webBkReefers.filter(
                                      function (item) {
                                        return item.intakeNum === "OPEN"
                                      }
                                    )
                                  )
                                    ? _c(
                                        "el-row",
                                        {
                                          staticStyle: {
                                            color: "red",
                                            "margin-top": "12px",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 5, offset: 19 } },
                                            [
                                              _vm._v(
                                                "\n                          何％ openかをRemarkに書いて下さい。\n                        "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "table-item-titel" }, [
                        _vm._v(
                          "\n                  Special Container：\n                  "
                        ),
                        _c(
                          "span",
                          { staticStyle: { position: "absolute", right: "0" } },
                          [
                            _c("el-checkbox", {
                              staticStyle: { "margin-right": "20px" },
                              attrs: {
                                "true-label": 1,
                                "false-label": 0,
                                disabled: _vm.detialType == "Preview",
                              },
                              on: { change: _vm.akCheckboxChange },
                              model: {
                                value: _vm.webBookingHead.akCheckFlag,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.webBookingHead,
                                    "akCheckFlag",
                                    $$v
                                  )
                                },
                                expression: "webBookingHead.akCheckFlag",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { colspan: "2" } }, [
                        _vm.webBookingHead.akCheckFlag == "1"
                          ? _c("div", [
                              _c(
                                "div",
                                { attrs: { STYLE: "margin-bottom: 10px" } },
                                [
                                  _vm.detialType !== "Preview"
                                    ? _c("el-button", {
                                        attrs: {
                                          type: "primary",
                                          icon: "el-icon-plus",
                                        },
                                        on: { click: _vm.addWebBkAks },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.detialType !== "Preview"
                                    ? _c("el-button", {
                                        attrs: {
                                          type: "primary",
                                          icon: "el-icon-minus",
                                        },
                                        on: { click: _vm.deleteWebBkAks },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "table-container-new" },
                                [
                                  _c(
                                    "el-table",
                                    {
                                      ref: "webBkAksRef",
                                      attrs: {
                                        data: _vm.webBookingHead.webBkAks,
                                        "cell-class-name":
                                          _vm.cellClassNameWebBkAks,
                                      },
                                      on: {
                                        "cell-click": _vm.cellClickWebBkAks,
                                      },
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "Container Type",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-select",
                                                    {
                                                      staticStyle: {
                                                        width: "78%!important",
                                                      },
                                                      attrs: {
                                                        placeholder: "",
                                                        disabled:
                                                          _vm.detialType ==
                                                          "Preview",
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row
                                                            .containerType,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "containerType",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.containerType",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.sizeList,
                                                      function (item) {
                                                        return _c("el-option", {
                                                          key: item,
                                                          attrs: {
                                                            label: item,
                                                            value: item,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3005799040
                                        ),
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "Length",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-input-number", {
                                                    staticStyle: {
                                                      width: "78%",
                                                    },
                                                    attrs: {
                                                      precision: 2,
                                                      "auto-cut": true,
                                                      controls: false,
                                                      max: 9999.99,
                                                      disabled:
                                                        _vm.detialType ==
                                                        "Preview",
                                                    },
                                                    model: {
                                                      value: scope.row.akLength,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "akLength",
                                                          typeof $$v ===
                                                            "string"
                                                            ? $$v.trim()
                                                            : $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.akLength",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "table-mini-primary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                            cm\n                          "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3563081810
                                        ),
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "Width",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-input-number", {
                                                    staticStyle: {
                                                      width: "78%",
                                                    },
                                                    attrs: {
                                                      precision: 2,
                                                      "auto-cut": true,
                                                      controls: false,
                                                      max: 9999.99,
                                                      disabled:
                                                        _vm.detialType ==
                                                        "Preview",
                                                    },
                                                    model: {
                                                      value: scope.row.akWidth,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "akWidth",
                                                          typeof $$v ===
                                                            "string"
                                                            ? $$v.trim()
                                                            : $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.akWidth",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "table-mini-primary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                            cm\n                          "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1393863784
                                        ),
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "Height",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-input-number", {
                                                    staticStyle: {
                                                      width: "78%",
                                                    },
                                                    attrs: {
                                                      precision: 2,
                                                      "auto-cut": true,
                                                      controls: false,
                                                      max: 9999.99,
                                                      disabled:
                                                        _vm.detialType ==
                                                        "Preview",
                                                    },
                                                    model: {
                                                      value: scope.row.akHigth,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "akHigth",
                                                          typeof $$v ===
                                                            "string"
                                                            ? $$v.trim()
                                                            : $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.akHigth",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "table-mini-primary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                            cm\n                          "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2015164980
                                        ),
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          label: "G/W",
                                          align: "center",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-input-number", {
                                                    staticStyle: {
                                                      width: "78%",
                                                    },
                                                    attrs: {
                                                      precision: 3,
                                                      "auto-cut": true,
                                                      controls: false,
                                                      max: 99999999999.999,
                                                      disabled:
                                                        _vm.detialType ==
                                                        "Preview",
                                                    },
                                                    model: {
                                                      value:
                                                        scope.row.akGrossWeight,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "akGrossWeight",
                                                          typeof $$v ===
                                                            "string"
                                                            ? $$v.trim()
                                                            : $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.akGrossWeight",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "table-mini-primary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                            kg\n                          "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          854747351
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "table-item-titel" }, [
                        _vm._v(
                          "\n                  Issue Type：\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { attrs: { colspan: "2" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "200px !important" },
                              attrs: {
                                disabled: _vm.detialType == "Preview",
                                placeholder: "",
                              },
                              model: {
                                value:
                                  _vm.webBookingHead.deliveryDocumentMethod,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.webBookingHead,
                                    "deliveryDocumentMethod",
                                    $$v
                                  )
                                },
                                expression:
                                  "webBookingHead.deliveryDocumentMethod",
                              },
                            },
                            _vm._l(_vm.issueTypList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.webBookingHead.deliveryDocumentMethod == 2
                      ? _c("tr", [
                          _vm._m(7),
                          _vm._v(" "),
                          _c(
                            "td",
                            { attrs: { colspan: "2" } },
                            [
                              _c("el-input", {
                                directives: [
                                  {
                                    name: "byte-length",
                                    rawName: "v-byte-length",
                                    value: 50,
                                    expression: "50",
                                  },
                                  { name: "trim", rawName: "v-trim" },
                                  { name: "fth", rawName: "v-fth" },
                                ],
                                attrs: {
                                  disabled: _vm.detialType == "Preview",
                                },
                                model: {
                                  value: _vm.deliveryDocumentCompany,
                                  callback: function ($$v) {
                                    _vm.deliveryDocumentCompany = $$v
                                  },
                                  expression: "deliveryDocumentCompany",
                                },
                              }),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "table-item-titel" }, [
                        _vm._v(
                          "\n                  " +
                            _vm._s(
                              _vm.$t("booking.bookingHistroryJpDetails.Payment")
                            ) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { attrs: { colspan: "2" } },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: {
                                label: 0,
                                disabled: _vm.detialType == "Preview",
                              },
                              model: {
                                value: _vm.webBookingHead.paidType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.webBookingHead, "paidType", $$v)
                                },
                                expression: "webBookingHead.paidType",
                              },
                            },
                            [_vm._v("PREPAID")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-radio",
                            {
                              attrs: {
                                label: 1,
                                disabled: _vm.detialType == "Preview",
                              },
                              model: {
                                value: _vm.webBookingHead.paidType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.webBookingHead, "paidType", $$v)
                                },
                                expression: "webBookingHead.paidType",
                              },
                            },
                            [_vm._v("COLLECT\n                  ")]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", { staticClass: "table-item-titel" }, [
                        _vm._v(
                          "\n                  Remark：\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { attrs: { colspan: "2" } },
                        [
                          _c("el-input", {
                            directives: [
                              {
                                name: "byte-length",
                                rawName: "v-byte-length",
                                value: 500,
                                expression: "500",
                              },
                              { name: "trim", rawName: "v-trim" },
                              { name: "fth", rawName: "v-fth" },
                            ],
                            attrs: {
                              type: "textarea",
                              rows: 2,
                              placeholder: "",
                              disabled: _vm.detialType == "Preview",
                            },
                            model: {
                              value: _vm.webBookingHead.remarkFromOutbound,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.webBookingHead,
                                  "remarkFromOutbound",
                                  $$v
                                )
                              },
                              expression: "webBookingHead.remarkFromOutbound",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "margin-top": "50px",
                  display: "flex",
                  "justify-content": "center",
                },
              },
              [
                _vm.detialType !== "Preview" &&
                (_vm.statusLabel === "DRAFT" || _vm.statusLabel === "NEW") &&
                _vm.showSave
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.saveFormData },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t(
                                "booking.bookingHistroryJpDetails.draftSaveButton"
                              )
                            ) +
                            "\n            "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.detialType !== "Preview" && _vm.showSave
                  ? _c(
                      "el-button",
                      {
                        staticStyle: {
                          "margin-left": "100px",
                          "margin-right": "100px",
                        },
                        attrs: { type: "primary" },
                        on: { click: _vm.SaveAndChangeSubmit },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t(
                                "booking.bookingHistroryJpDetails.confirmButton"
                              )
                            ) +
                            "\n            "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.detialType !== "Preview" && _vm.showSubmit
                  ? _c(
                      "el-button",
                      {
                        staticStyle: {
                          "margin-left": "100px",
                          "margin-right": "100px",
                        },
                        attrs: { type: "primary" },
                        on: { click: _vm.submitForm },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.$t(
                                "booking.bookingHistroryJpDetails.submitButton"
                              )
                            ) +
                            "\n            "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.backJpBookingHistory },
                  },
                  [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$t("booking.bookingHistroryJpDetails.backButton")
                        ) +
                        "\n            "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("sail-schedule-vess-name", {
        ref: "sailSchedule",
        attrs: {
          "destroy-on-close": true,
          width: "70%",
          visible: _vm.sailScheduleDialogVisible,
        },
        on: {
          selectionChange: _vm.selectionChangeSailSchedule,
          closeDialog: _vm.closeDialog,
          "update:visible": function ($event) {
            _vm.sailScheduleDialogVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "table-td-second" }, [
      _vm._v("\n                  Company Name\n                  "),
      _c("span", { staticClass: "table-item-red" }, [
        _vm._v("\n                   ※1\n                "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "table-td-second" }, [
      _vm._v("\n                  PIC\n                  "),
      _c("span", { staticClass: "table-item-red" }, [
        _vm._v("\n                   ※1\n                "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "table-td-second" }, [
      _vm._v("\n                  Tel\n                  "),
      _c("span", { staticClass: "table-item-red" }, [
        _vm._v("\n                   ※1\n                "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "table-item-red", staticStyle: { "margin-top": "10px" } },
      [
        _c("div", [
          _vm._v(
            "\n                      ※1　海貨業者様が確定している場合は記載をお願い致します｡Dock Receipt未着の際にこちらに直接問い合わせ致します。\n                    "
          ),
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n                           Please input if your broker has been determined, we will contact with them if\n                      the sending of the Dock Receipt was delayed.\n                    "
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-top": "10px" } }, [
      _c("div", {}, [
        _c("div", [
          _vm._v(
            "\n                        ※ チェックマークを入れて頂きますと、記載されたFax NO.とE-mailアドレスにフレートメモを送付致します。\n                      "
          ),
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "\n                             The freight memo will be sent to the Fax No. or to the E-mail address by clicking the check mark.\n                      "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-top": "10px" } }, [
      _c("div", {}, [
        _c("div", [
          _vm._v(
            '\n                        ※ 複数E-mailアドレスへの送付をご希望の場合、E-mailアドレス間に";"を入力頂きますようお願い致します。\n                      '
          ),
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            '\n                             If you want to register multiple email addresses, please enter ";" between the email addresses.\n                      '
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "table-item-titel" }, [
      _vm._v("\n                  Cargo Commodity\n                  "),
      _c("span", { staticClass: "table-item-red" }, [
        _vm._v("\n                  ※\n                "),
      ]),
      _vm._v("\n                  :\n                "),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { staticClass: "table-item-titel" }, [
      _vm._v("\n                  Consignee Name\n                  "),
      _c("span", { staticClass: "table-item-red" }, [
        _vm._v("\n                  ※\n                "),
      ]),
      _vm._v("\n                  :\n                "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }